import type { SandboxStatus } from "@app/lib/resources/storage/models/sandbox";
import { assertNever } from "@app/types/shared/utils/assert_never";
import { Chip } from "@dust-tt/sparkle";

interface SandboxStatusChipProps {
  status: SandboxStatus;
}

export function SandboxStatusChip({ status }: SandboxStatusChipProps) {
  switch (status) {
    case "running":
      return <Chip size="mini" color="success" label="Computer running" />;
    case "sleeping":
      return <Chip size="mini" color="warning" label="Computer sleeping" />;
    case "pending_approval":
      return <Chip size="mini" color="warning" label="Waiting for approval" />;
    case "deleted":
      return <Chip size="mini" color="primary" label="Computer expired" />;
    default:
      assertNever(status);
  }
}
